import { FormEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { unlockSiteGate } from '../api/siteGate'
import BrandWordmark from './BrandWordmark'

type Props = {
  onUnlocked: () => void
}

export default function SiteGateScreen({ onUnlocked }: Props) {
  const { t } = useTranslation()
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await unlockSiteGate(password.trim())
      setPassword('')
      onUnlocked()
    } catch (e) {
      const msg = e instanceof Error ? e.message : ''
      if (msg.toLowerCase().includes('invalid access password')) {
        setError(t('siteGate.invalid', 'Neteisingas slaptažodis'))
      } else {
        setError(t('siteGate.networkError', 'Nepavyko prisijungti prie serverio. Patikrinkite, ar veikia API.'))
      }
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="site-gate" role="dialog" aria-modal="true" aria-labelledby="site-gate-title">
      <div className="site-gate__card">
        <BrandWordmark className="brand-wordmark--gate" />
        <h1 id="site-gate-title" className="site-gate__title">
          {t('siteGate.title', 'Privati peržiūra')}
        </h1>
        <p className="site-gate__hint">{t('siteGate.hint', 'Svetainė dar nevieša. Įvesk prieigos slaptažodį.')}</p>
        <form className="site-gate__form" onSubmit={onSubmit}>
          <label className="site-gate__label" htmlFor="site-gate-password">
            {t('siteGate.password', 'Slaptažodis')}
          </label>
          <input
            id="site-gate-password"
            name="password"
            type="password"
            autoComplete="current-password"
            className="site-gate__input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={busy}
            required
          />
          {error && (
            <p className="site-gate__error" role="alert">
              {error}
            </p>
          )}
          <button type="submit" className="site-gate__submit" disabled={busy || !password.trim()}>
            {busy ? t('common.loading', 'Loading...') : t('siteGate.enter', 'Įeiti')}
          </button>
        </form>
      </div>
    </div>
  )
}
